import React, { useState, useEffect } from 'react';
import { gridFilterModelSelector } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import FileFolderItem from '../FileFolderItem';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = (props) => {
    const [searchText, setSearchText] = useState('');
    const [file, setFile] = useState(null);
    const [files, setFiles] = useState([]);

    useEffect(() => {
        let filtered = props.rows.filter(row => row.file_name !== null);
        if (props.client && props.client.client) {
            filtered = filtered.filter(row => Array.isArray(row.file_path) && row.file_path.includes(props.client.client));
        }
        setFiles(filtered);
    }, [props.rows, props.client]);

    useEffect(() => {
        if (searchText === '') {
            let gridFilterModel = gridFilterModelSelector(props.apiRef.current.state);
            let newFilterModel = { ...gridFilterModel };

            newFilterModel.items = newFilterModel.items.filter(item => item.field !== "file_name" && item.field !== "id");

            props.apiRef.current.setFilterModel(newFilterModel);
            props.setIsExpanded(false);
        }
    }, [searchText]);

    const onSearch = () => {
        if(searchText.trim() === '') 
            return;

        let gridFilterModel = gridFilterModelSelector(props.apiRef.current.state);
        let newFilterModel = { ...gridFilterModel };

        newFilterModel.items = newFilterModel.items.filter(item => item.field !== "file_name" && item.field !== "id");

        file ? newFilterModel.items.push({ field: "id", operator: "equals", value: file.id + ""}) :
        newFilterModel.items.push({ field: "file_name", operator: "contains", value: searchText});

        props.apiRef.current.setFilterModel(newFilterModel);
        props.setIsExpanded(true);
    }


    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-end', minWidth: "200px", width: "100%" }}>
            <AutoComplete
                freeSolo
                value={file}
                inputValue={searchText}
                onChange={(e, value) => setFile(value)}
                onInputChange={(e, value) => setSearchText(value)}
                options={files}
                sx={{ width: "100%", marginRight: .5 }}
                size="small"
                getOptionLabel={(option) => option.file_name + "." + option.file_ext}
                renderOption={(props, option) => <FileFolderItem listItemProps={props} row={option} />}
                renderInput={(params) => 
                    <TextField 
                        {...params} 
                        label="Search" 
                        variant="outlined"
                />}
            />
            <Button variant="outlined" sx={{ height: "40px", minWidth: "40px", padding: 0.25, margin: 0 }}>
                <SearchIcon onClick={onSearch} />
            </Button>
        </Box>
    )
}

export default SearchBar;